<div class="flex flex-col gap-16 p-5">
  <!-- Sección de la cabecera. -->
  <section class="w-full flex flex-col items-center gap-5">
    <div class="text-2xl font-medium text-center">
      ¡Activación realizada con éxito!
    </div>
    <p class="w-10/12 text-center">
      Asegúrate de copiar las credenciales y pegarlas en el programa para
      completar la configuración.
    </p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="w-full flex flex-col gap-5">
    <div class="flex gap-5">
      <div class="w-3/6 font-medium flex items-center justify-end text-right">
        Código:
      </div>
      <div class="w-3/6 flex items-center justify-between">
        <code class="bg-gray-200">
          {{ activation.code }}
        </code>
        <button
          mat-icon-button
          aria-label="Copiar código"
          (click)="copyToClipboard(activation.code ?? '')"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <div class="flex gap-5">
      <div class="w-3/6 font-medium flex items-center justify-end text-right">
        Número de serie:
      </div>
      <div class="w-3/6 flex items-center justify-between">
        <code class="bg-gray-200">
          {{ activation.serial }}
        </code>
        <button
          mat-icon-button
          aria-label="Copiar número de serie"
          (click)="copyToClipboard(activation.serial ?? '')"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <div class="flex gap-5">
      <div class="w-3/6 font-medium flex items-center justify-end text-right">
        Contraseña:
      </div>
      <div class="w-3/6 flex items-center justify-between">
        <code class="bg-gray-200">
          {{ activation.password }}
        </code>
        <button
          mat-icon-button
          aria-label="Copiar contraseña"
          (click)="copyToClipboard(activation.password ?? '')"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>
  </section>

  <!-- Sección de acciones. -->
  <section class="flex justify-end gap-5">
    <button type="button" mat-raised-button (click)="dialogRef.close()">
      Cerrar
    </button>
  </section>
</div>
